import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "my-4 w-full max-w-5xl px-8 py-4 border-l-8 no-last-margin tight-p border-blue-700 text-blue-900 bg-blue-200" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("span", { class: "sr-only" }, "Information:", -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", { class: "block font-bold text-2xl xl:text-3xl mb-2 text-blue-700" }, "Under development", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "whitespace-pre-wrap" }, [
  /*#__PURE__*/_createElementVNode("p", null, "This content is currently under development, incomplete, and should not currently be used.")
], -1)
const _hoisted_5 = [
  _hoisted_2,
  _hoisted_3,
  _hoisted_4
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, _hoisted_5))
}